import { apiGet } from '../utils';

const getLoginUrl = async () => {
    const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH}/login`;
    return await apiGet(url);
};

const getToken = async (params) => {
    const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH}/token?queryString=${params}`;
    const options = {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
            'x-api-key': process.env.REACT_APP_API_KEY
        }
    };
    const response = await fetch(url, options);

    sessionStorage.setItem('AUTH', await response.text())

    return response.status===200;
    // const json = await response.json();
    // return json.bearerAccessToken ? json.bearerAccessToken.value : null;
};

const getUserInfo = async() => {
    const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH}/user/info`;
    return await apiGet(url);
};

const logout = async() => {
    const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH}/user/logout`;
    return await apiGet(url);
};

export {
    getLoginUrl,
    getToken,
    getUserInfo,
    logout
};
